import classes from './Title.module.scss';

export const Title = ({ title }: { title: string }) => {
  return (
    <div className={classes.titleWrapper}>
      <h1 className={classes.sectionTitle}>{title}</h1>
      <img
        src="https://ik.imagekit.io/hg5cblo5w/articles/separator_resized_compressed%20(1).webp?updatedAt=1749498987481"
        alt="Separation"
        className={`${classes.horizontalSectionDivider} mb-5`}
      />
    </div>
  );
};
